import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownProps {
  /** Seconds remaining when the page loads. */
  initialSeconds: number;
  size?: 'md' | 'lg';
  /** 'dark' for light backgrounds, 'light' for dark backgrounds. */
  tone?: 'dark' | 'light';
}
const units = ['Hours', 'Min', 'Sec'] as const;
export function Countdown({
  initialSeconds,
  size = 'md',
  tone = 'dark'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(initialSeconds);
  const values = [hours, minutes, seconds];
  const digitColor = tone === 'light' ? 'text-paper' : 'text-ink';
  const labelColor = tone === 'light' ? 'text-paper-400' : 'text-ink-muted';
  return <div className="flex items-start gap-2.5 sm:gap-4" role="timer" aria-live="off" data-id="element-74" data-mp="372t26il4egub">
      {values.map((value, index) => <React.Fragment key={units[index]} data-id="element-75" data-mp="10c3hfsqp8256" data-mpi={index}>
          {index > 0 && <span className={`font-display leading-none text-gold ${size === 'lg' ? 'text-4xl sm:text-6xl' : 'text-3xl sm:text-5xl'}`} aria-hidden="true" data-id="element-76" data-mp="15bg4oelhfb8a">
              :
            </span>}
          <div className="flex flex-col items-center" data-id="element-77" data-mp="szzbz7o6x0ig">
            <span className={`tabular-nums font-display font-semibold leading-none ${digitColor} ${size === 'lg' ? 'text-4xl sm:text-7xl' : 'text-3xl sm:text-6xl'}`} data-id="element-78" data-mp="17py874w6q1va">
              {value}
            </span>
            <span className={`mt-2 text-[10px] font-semibold uppercase tracking-label ${labelColor}`} data-id="element-79" data-mp="a37p6o9fw39n">
              {units[index]}
            </span>
          </div>
        </React.Fragment>)}
    </div>;
}